"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEndSection = void 0;
const DefaultSubsections = require("./helpers/defaultSubsections");
function buildEndSection(section) {
    return {
        type: 'end',
        description: section.description || `Conclusion section`,
        subsections: [DefaultSubsections.patientID()],
    };
}
exports.buildEndSection = buildEndSection;
//# sourceMappingURL=endSection.js.map